// Auto-rotate product images without breaking theme functionality
theme.productImageRotation = (function() {
  // Configuration
  const ROTATION_INTERVAL = 1000; // 3 seconds exactly
  
  // Selectors for DOM elements based on Shopify Impulse theme structure
  const selectors = {
    productSlideshow: '.product-slideshow',
    productThumbs: '.product__thumbs--scroller',
    productThumbItem: '.product__thumb-item',
    productThumb: '.product__thumb'
  };
  
  // State variables
  let rotationTimer = null;
  let currentIndex = 0;
  let thumbItems = [];
  let isPlaying = false;
  let slideCount = 0;
  
  // Safely click the thumbnail to change slides using the theme's built-in functionality
  function changeSlideViaThumb(index) {
    if (thumbItems[index]) {
      const thumbLink = thumbItems[index].querySelector(selectors.productThumb);
      if (thumbLink) {
        // Use native click() method which is most compatible
        thumbLink.click();
      }
    }
  }
  
  // Move to next slide
  function rotateToNextSlide() {
    currentIndex = (currentIndex + 1) % slideCount;
    changeSlideViaThumb(currentIndex);
  }
  
  // Start the rotation with exact timing
  function startRotation() {
    if (isPlaying) return;
    
    isPlaying = true;
    rotationTimer = setInterval(rotateToNextSlide, ROTATION_INTERVAL);
  }
  
  // Stop the rotation
  function stopRotation() {
    if (!isPlaying) return;
    
    isPlaying = false;
    clearInterval(rotationTimer);
    rotationTimer = null;
  }
  
  // Setup event listeners to pause rotation on user interaction
  function setupEventListeners() {
    const slideshow = document.querySelector(selectors.productSlideshow);
    const thumbsContainer = document.querySelector(selectors.productThumbs);
    
    // Stop rotation on user interaction with slideshow
    if (slideshow) {
      slideshow.addEventListener('mouseenter', stopRotation);
      slideshow.addEventListener('click', stopRotation);
    }
    
    // Stop rotation on user interaction with thumbnails
    if (thumbsContainer) {
      thumbsContainer.addEventListener('mouseenter', stopRotation);
      thumbsContainer.addEventListener('click', stopRotation);
    }
    
    // Resume rotation when mouse leaves the product section
    const productSection = document.querySelector('.product-section');
    if (productSection) {
      productSection.addEventListener('mouseleave', function(event) {
        // Only restart if moving outside the product section
        if (!productSection.contains(event.relatedTarget)) {
          startRotation();
        }
      });
    }
    
    // Handle tab visibility changes
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopRotation();
      } else {
        startRotation();
      }
    });
  }
  
  // Initialize when DOM is ready
  function init() {
    // Find thumbnail elements
    thumbItems = document.querySelectorAll(selectors.productThumbItem);
    slideCount = thumbItems.length;
    
    // Don't initialize if there's only one image
    if (slideCount <= 1) return;
    
    // Setup event handlers
    setupEventListeners();
    
    // Start rotation with a slight delay to ensure everything is loaded
    setTimeout(function() {
      startRotation();
    }, 1000);
  }
  
  // Public API
  return {
    init: init,
    start: startRotation,
    stop: stopRotation
  };
})();

// Initialize when the page loads
document.addEventListener('DOMContentLoaded', function() {
  // Give the theme a moment to set up its own image handlers first
  setTimeout(function() {
    theme.productImageRotation.init();
  }, 1000);
});